import React from 'react'
import { Typography } from 'antd'
import LandingLayout from '@layouts/LandingLayout'

export default () => (
  <LandingLayout activeTab = '1'>
    <div className='flex flex-col items-center'>
      <Typography.Title className='text-primary-color'>
        Hi there, I'm Basel!
      </Typography.Title>
      <Typography.Title level={4} className='text-gray-600'>
        I'm a software engineer who loves computer science and learning. My interests include Cybersecurity, Automation, and Accessibility. I spent the past year working at Continental, an automotive supplier, and am looking to put the skills I learned there to good use. In my spare time I like to explore new technologies, work out, game and push my limits.<br/><br/>
        My skillset includes automotive and embedded tools like CANoe and TRACE32 along with many object oriented languages with Python, C++, and Java along with database management in SQL, SQLite, Microsoft Azure DB and Google Firebase. I am learning front end web and mobile development in HTML, CSS, React.js, React Native and Flutter with a few projects done in Android as well.  
      </Typography.Title>
      {/*<img src='/cover.png' alt='logo' className='mt-10' />*/}
    </div>
  </LandingLayout>
)
